export default {
  title: 'Generate QR Codes',

  name: "Bucket's name",
  amount: 'QR Codes amount'
}
